import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useHistory } from 'react-router-dom';
import { PageTitle } from '@cordata/buffet';
import { UncontrolledTable } from '~/components';

import { usePatient } from '~/utils';

const DiagnosesCollection = () => {
  const history = useHistory();
  const [, patient] = usePatient();

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to={`/patients/${patient.id}/diagnoses/add`}
          >
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline ml-2">Add Diagnosis</span>
          </Button>
        }
      >
        Diagnoses
      </PageTitle>

      <UncontrolledTable
        name="patient-diagnoses"
        endpoint={{
          instance: 'r',
          url: `patients/${patient.id}/diagnoses`,
        }}
        defaultSorted={[
          { id: 'attributes.isPrimaryDiagnosis', desc: false },
        ]}
        columns={[{
          id: 'isPrimaryDiagnosis',
          accessor: 'attributes.isPrimaryDiagnosis',
          cellType: 'primary-indicator',
        }, {
          id: 'diagnosis',
          Header: 'Diagnosis',
          accessor: 'relationships.diagnosis.attributes.diagnosisLabel',
        }, {
          id: 'region',
          Header: 'Region',
          accessor: 'relationships.region.attributes.regionLabel',
        }, {
          id: 'onsetDate',
          Header: 'Onset Date',
          accessor: 'attributes.onsetDate',
          cellType: 'date',
        }, {
          id: 'status',
          Header: 'Status',
          accessor: 'relationships.status.attributes.referenceStatus.statusLabel',
        }, {
          id: 'provider',
          Header: 'Provider',
          accessor: 'relationships.provider.attributes.displayName',
        }]}
        getTrProps={(state, rowInfo) => ({
          ...rowInfo?.original.attributes.isPrimaryDiagnosis && {
            style: {
              fontWeight: 'bold',
            },
          },
          onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/patients/${patient.id}/diagnoses/${rowInfo.original.id}/details`, rowInfo.original)),
        })}
      />
    </>
  );
};

export default DiagnosesCollection;
